var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRuntimeinline = function SvgRuntimeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFDEFC",
    d: "M76 0H4a4 4 0 0 0-4 4v72a4 4 0 0 0 4 4h72a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#689AFF",
    stroke: "#253737",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M59 41.567c0 4.645-2.002 10.173-5.565 13.457C49.872 58.31 43.167 62 40 62s-9.872-3.691-13.435-6.976C23.002 51.74 21 46.212 21 41.567V24.439L40 18l19 6.439z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#253737",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m34 34-5 5 5 5m13-10 5 5-5 5m-5-11-3 12"
  })));
};
export default SvgRuntimeinline;